import { axiosEduServer } from "../utils/configAxios";

export const crearModulo = (data) => {
  return axiosEduServer.post('/modulo', data).then(({ data }) => data).catch((err) => { console.log(err); throw err });
};

export const actualizarModulo = (id, data) => {
  return axiosEduServer.put(`/modulo/${id}`, data).then(({ data }) => data).catch((err) => { console.log(err); throw err });
};

export const eliminarModulo = (id) => {
  return axiosEduServer.delete(`/modulo/${id}`).then(({ data }) => data).catch((err) => { console.log(err); throw err });
};

export const getOneModulo = (id) => {
  return axiosEduServer.get(`/modulo/${id}`).then(({ data }) => data).catch((err) => { console.log(err); throw err });
};

export const getAllModulos = () => {
  return axiosEduServer.get('/modulo').then(({ data }) => data).catch((err) => { console.log(err); throw err });
};

export const getAllModulosByIdIdioma = (idIdioma) => {
  return axiosEduServer.get(`/modulo/ididioma/${idIdioma}`).then(({ data }) => data).catch((err) => { throw err });
}

export const getAllModulosByIdNivelAndIdIdioma = (idNivel, idIdioma) => {
  return axiosEduServer.get(`/modulo/idNivel/${idNivel}/ididioma/${idIdioma}`).then(({ data }) => data).catch((err) => { throw err });
}